export function ensureCurrencyIsPresent(price) {
  if (price == null || Number.isNaN(price)) {
    return '';
  }

  return price.toString().startsWith('$') ? price : `$${price}`;
}

export function getPaymentAndSupportListItems(amount, dogPayment = false) {
  const amountText = amount
    ? `${ensureCurrencyIsPresent(parseFloat(amount).toFixed(2))} `
    : '';

  return [
    `Your ${amountText}payment is fully covered by Good Dog Payment Protection`,
    `Our team will jump in to help if anything goes wrong`,
    dogPayment &&
      'Exclusive discounts on puppy essentials from Chewy, Rover, BarkBox and more',

    dogPayment &&
      'Lifetime access to our Puppy Training Program, including live coaching and a supportive community, valued at $235'
  ].filter(Boolean);
}

export function getBasicProtectionAndSupportListItems(
  amount,
  dogPayment = false
) {
  const amountText = amount
    ? `${ensureCurrencyIsPresent(parseFloat(amount).toFixed(2))} `
    : '';

  return [
    !dogPayment &&
      `Your ${amountText}payment is not covered by Good Dog Payment Protection`,
    dogPayment && 'Our team will not be able to mediate any issues',
    !dogPayment &&
      'Our team will not be able to support you if an issue arises',
    dogPayment && 'Lose access to puppy training & coaching',
    'Designed specifically for trusted friends & family'
  ].filter(Boolean);
}

export function isFormattedAmountZero(formattedAmount) {
  if (!formattedAmount) {
    return true;
  }

  const numericValue = parseFloat(
    formattedAmount.toString().replace(/[$,\s]/g, '')
  );

  if (Number.isNaN(numericValue)) {
    return true;
  }

  return numericValue === 0;
}
